
import React from 'react';
import { MapPin, Footprints, Minus, Pentagon, FolderOpen, Layers } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ContentType } from '../../types';

interface MyContentEmptyStateProps {
  type: ContentType | 'folders';
}

const ICONS: Record<string, React.ReactNode> = {
  all: <Layers size={28} className="text-[var(--text-muted)]" />,
  waypoint: <MapPin size={28} className="text-[var(--text-muted)]" />,
  track: <Footprints size={28} className="text-[var(--text-muted)]" />,
  line: <Minus size={28} className="text-[var(--text-muted)]" strokeWidth={3} />,
  area: <Pentagon size={28} className="text-[var(--text-muted)]" />,
  folders: <FolderOpen size={28} className="text-[var(--text-muted)]" />,
};

const I18N_KEYS: Record<string, { title: string; subtitle: string }> = {
  all: { title: 'myContent.empty.all_title', subtitle: 'myContent.empty.all_subtitle' },
  waypoint: { title: 'myContent.empty.waypoint_title', subtitle: 'myContent.empty.waypoint_subtitle' },
  track: { title: 'myContent.empty.track_title', subtitle: 'myContent.empty.track_subtitle' },
  line: { title: 'myContent.empty.line_title', subtitle: 'myContent.empty.line_subtitle' },
  area: { title: 'myContent.empty.area_title', subtitle: 'myContent.empty.area_subtitle' },
  folders: { title: 'myContent.empty.folders_title', subtitle: 'myContent.empty.folders_subtitle' },
};

const MyContentEmptyState: React.FC<MyContentEmptyStateProps> = ({ type }) => {
  const { t } = useTranslation();
  const keys = I18N_KEYS[type] ?? I18N_KEYS.all;
  const icon = ICONS[type] ?? ICONS.all;

  return (
    <div className="flex flex-col items-center justify-center py-12 gap-3">
      <div className="w-14 h-14 rounded-2xl bg-[var(--bg-input)]/60 border border-[var(--border-primary)] flex items-center justify-center">
        {icon}
      </div>
      <p className="text-[12px] font-bold text-[var(--text-secondary)]">{t(keys.title)}</p>
      <p className="text-2xs text-[var(--text-muted)] text-center max-w-[240px] leading-relaxed">{t(keys.subtitle)}</p>
    </div>
  );
};

export default MyContentEmptyState;
